export const MEALS = [
  { key: "colazione", label: "Colazione" },
  { key: "pranzo", label: "Pranzo" },
  { key: "cena", label: "Cena" },
  { key: "spuntino", label: "Spuntini" },
];

export const toISO = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const todayISO = () => toISO(new Date());
export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return toISO(d);
};
export const prettyDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
export const shortDay = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", { weekday: "short" }).replace(".", "");

export const scale = (food, grams) => {
  const f = (Number(grams) || 0) / 100;
  return {
    kcal: Math.round((food?.kcal || 0) * f),
    protein: Math.round((food?.protein || 0) * f * 10) / 10,
    carbs: Math.round((food?.carbs || 0) * f * 10) / 10,
    fat: Math.round((food?.fat || 0) * f * 10) / 10,
  };
};

export const resizeToBase64 = (file, max = 1024) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const r = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * r);
      c.height = Math.round(img.height * r);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(img.src);
      resolve(c.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
